import Model from './Model'

export default class Field extends Model {
  id: number
  titleId: number
  isIdentifier: boolean
  name: string
  required: boolean
  title: string
  type: string
  value: string
  listLabels: []
  listValues: []

  constructor(field, locale) {
    super({})


    this.id = field.id
    this.name = field.name
    this.type = field.type
    this.required = field.required
    this.value = field.value
    this.isIdentifier = field.identifier || false
    this.title = this.translateField(field._title, locale)
    this.titleId = field.title

    if (field.type === 'list') {
      this.listLabels = field.parameters._list.map((label) => this.translateField(label, locale))
      this.listValues = field.parameters._list.map((label) => label.id)
    }
  }
}
